/**
 * CardPlanIcon – SVG icon.
 */
import CardPlanIconContainer from '@components/atoms/container/cardPlanIconContainer';
import IArrow from '@shared/types/props/arrow';
import Screen from '@screen';

/** Plan / subscription icon for cards. */
export default function CardPlanIcon({
  focused,
  ratio = 1,
  height = 17,
  width = 16,
}: IArrow) {
  return (
    <CardPlanIconContainer focused={focused}>
      <svg
        width={`${width * ratio * Screen.widthRatio}`}
        height={`${height * ratio * Screen.widthRatio}`}
        viewBox='0 0 16 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.08296 0.29718C8.63893 0.29718 9.08963 0.744895 9.08963 1.29718V15.2972C9.08963 15.8495 8.63893 16.2972 8.08296 16.2972C7.52699 16.2972 7.07629 15.8495 7.07629 15.2972V1.29718C7.07629 0.744895 7.52699 0.29718 8.08296 0.29718Z'
          fill={'white'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.08291 0.29718C8.37085 0.29718 8.645 0.419661 8.83605 0.633655L15.0856 7.63366C15.4545 8.04685 15.4164 8.67888 15.0004 9.04533C14.5845 9.41179 13.9482 9.3739 13.5793 8.9607L8.08291 2.80428L2.58648 8.9607C2.21758 9.3739 1.58134 9.41179 1.16539 9.04533C0.749441 8.67888 0.711299 8.04685 1.0802 7.63366L7.32977 0.633655C7.52082 0.419661 7.79497 0.29718 8.08291 0.29718Z'
          fill={'white'}
        />
      </svg>
    </CardPlanIconContainer>
  );
}
